@let _errorAuth = errorAuth();
@let _retryAfter = retryAfter();

<div id="login" class="inner-scroll flex flex-row">
  <div id="login-intro" class="flex-1 xs:hidden">
    <div class="logo zoom-in">
      <img src="assets/images/logos/fluid-logo.png" alt="Fluid Logo" />
    </div>

    <div class="title delay-50! slide-up">
      {{ 'Benvenuto su FLUID!' | translate }}
    </div>
  </div>

  <div id="login-form-wrapper" class="flex flex-col delay-300! slide-left">
    <div id="login-form" class="flex-1 p-24 pt-128">
      <div class="logo gt-xs:hidden">
        <img
          [src]="
            ThemeService.isDarkMode() ? 'assets/images/logos/fluid-logo.png' : 'assets/images/logos/fluid-logo-alt.png'
          "
          alt="FluidNext Logo"
        />
      </div>

      <div class="title h1">{{ 'Login' | translate }}</div>

      <form name="loginForm" [formGroup]="loginForm" novalidate>
        <mat-form-field class="mb-24">
          <mat-label>{{ 'Username' | translate }}</mat-label>
          <input
            name="username"
            matInput
            autocomplete="username"
            [placeholder]="'Username' | translate"
            formControlName="username"
            (keypress)="keypressEvent($event)"
          />
          <mat-error appGlobalErrors></mat-error>
        </mat-form-field>

        <mat-form-field class="mb-24">
          <mat-label>{{ 'Password' | translate }}</mat-label>
          <input
            matInput
            name="password"
            [type]="showPassword() ? 'text' : 'password'"
            autocomplete="current-password"
            [placeholder]="'Password' | translate"
            formControlName="password"
            (keypress)="keypressEvent($event)"
          />
          <button
            class="toggle-password-visibility"
            type="button"
            matSuffix
            mat-icon-button
            (click)="togglePasswordVisibility($event)"
          >
            <mat-icon>{{ showPassword() ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
          <mat-error appGlobalErrors></mat-error>
        </mat-form-field>

        @if (_errorAuth) {
          <mat-error>
            @switch (_errorAuth) {
              @case (LoginErrorsEnum.required2FA) {
                {{ 'Richiesta autenticazione a due fattori' | translate }}
              }
              @case (LoginErrorsEnum.userDisabled) {
                {{ 'Utente non abilitato' | translate }}
              }
              @case (LoginErrorsEnum.wrongCredentials) {
                {{ 'Credenziali errate' | translate }}
              }
              @case (LoginErrorsEnum.notFound) {
                {{ 'Utente non trovato' | translate }}
              }
              @case (LoginErrorsEnum.tooManyAttempts) {
                {{ 'Troppi tentativi falliti. Riprovare tra' | translate }}
                <app-duration [time]="_retryAfter" [options]="{ hideEmpty: true }"></app-duration>
              }
              @case (LoginErrorsEnum.serverError) {
                {{ 'Si è verificato un errore. Riprovare più tardi.' | translate }}
              }
            }
          </mat-error>
        }

        <div class="remember-forgot-password flex flex-row xs:flex-col justify-between items-center">
          <mat-checkbox class="remember-me" aria-label="Ricordami" formControlName="remember">
            {{ 'Ricordami' | translate }}
          </mat-checkbox>
          <a class="forgot-password" [routerLink]="'/forgot-password'"> {{ 'Password dimenticata?' | translate }} </a>
        </div>

        <button
          #submitButton
          type="button"
          mat-raised-button
          color="primary"
          class="submit-button"
          aria-label="LOGIN"
          [form]="loginForm"
          [onSubmit]="onSubmit"
          (beforeSubmit)="beforeSubmit()"
          (afterSubmit)="afterSubmit($event)"
          (afterError)="afterError($event)"
          successMessage=""
        >
          {{ 'LOGIN' | translate }}
        </button>
      </form>
    </div>

    <div class="text-right mt-24 mr-24">
      <img
        class="inline-block"
        src="assets/images/positivessl_trust_seal_lg_120.png"
        width="120"
        alt="PositiveSSL Trust Seal"
      />
    </div>

    @let _currentLanguage = currentLanguage();
    @if (languages?.length && _currentLanguage) {
      <div class="pt-24 mb-24 pr-12 text-right">
        <!-- LANGUAGES -->
        <button mat-button class="language-button" [matMenuTriggerFor]="languageMenu">
          <div class="flex flex-row items-center gap-4">
            <img class="flag" [src]="_currentLanguage.imagePath" alt="Flag" />
            <span class="iso uppercase">{{ _currentLanguage.code }}</span>
          </div>
        </button>
        <mat-menu #languageMenu="matMenu" [overlapTrigger]="false">
          @for (lang of languages; track lang.code) {
            <button mat-menu-item (click)="setLanguage(lang)">
              <span class="flex flex-row items-center gap-4">
                <img class="flag" [src]="lang.imagePath" alt="Flag" />
                <span class="iso">{{ lang.name }}</span>
              </span>
            </button>
          }
        </mat-menu>
      </div>
    }
  </div>
</div>
